export enum IntelligenceRequestStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
  FULFILLED = 'fulfilled',
  ACCEPTED_BY_REVIEW_AUTHOR = 'accepted_by_review_author',
  PAUSED = 'paused',
  PENDING = 'pending',
  REJECTED = 'rejected',
}
